<template>
    <div :id="Skeleton.ID"  class="lines-container__line" >
        <div
            class="line no-outline">
            <div v-if="props.hasTitle" class="line__title-skeleton" />
            <div
                ref="root"
                class="line__content"
                :class="{ 'line__content_wrap': props.isMultiline }"
                data-type="line-content"
            >
                <div
                    v-for="(_item, index) in cardItems"
                    :key="index"
                    class="line__card"
                    :class="{ wrap: props.isMultiline }"
                    data-type="card"
                >
                    <base-card-skeleton>
                        <component :is="components[props.name]"/>
                    </base-card-skeleton>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { AppConstants } from "@/common";
    import { ChannelCardSkeleton, MovieCardSkeleton, ProgramCardSkeleton, BaseCardSkeleton, CreditCardSkeleton, TabsGenresCardSkeleton } from "./components";
    import { ComponentName, Skeleton } from "./types";

    const props = defineProps({
        name: {
            type: String as PropType<ComponentName>,
            required: true
        },
        hasTitle: {
            type: Boolean,
            required: false,
            default: true,
        },
        isMultiline: {
            type: Boolean,
            required: false,
            default: false
        },
    });

    const cardItems: Array<number> = new Array(AppConstants.SkeletonCardLength).fill(0).map((_, idx) => idx);
    const components: Record<ComponentName, ReturnType<typeof defineComponent>> = {
        [ComponentName.PROGRAM_CARD_SKELETON]: ProgramCardSkeleton,
        [ComponentName.CHANNEL_CARD_SKELETON]: ChannelCardSkeleton,
        [ComponentName.MOVIE_CARD_SKELETON]: MovieCardSkeleton,
        [ComponentName.CREDIT_CARD_SKELETON]: CreditCardSkeleton,
        [ComponentName.TABSGENRES_CARD_SKELETON]: TabsGenresCardSkeleton
    };
</script>
